import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import * as services from "../services"
import { REQUESTS_GIFTS_SLICE_NAME } from "./requestsGifts.constants"

export const getRequestsGifts = createAsyncThunk(
  `${REQUESTS_GIFTS_SLICE_NAME}/get_requests_gifts`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsGifts(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
